import type { Image } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const getMovieMetaLogo = (
    horizontalLogo: Image | null
): { logoUrl?: string; width?: number; height?: number } | undefined => {
    if (!horizontalLogo) {
        return;
    }

    const logoUrl = horizontalLogo.avatarsUrl ? `${horizontalLogo.avatarsUrl}/orig` : undefined;
    const { width, height } = horizontalLogo.origSize || {};

    return { logoUrl, width, height };
};
